import { RouterProvider } from "@tanstack/react-router";
import { Toaster, ToastBar, toast } from "react-hot-toast";
import { ErrorBoundary as AppErrorBoundary, type FallbackProps } from "react-error-boundary";
import { X } from "lucide-react";
import { router } from "./routes";

const getErrorMessage = (error: unknown) => {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  return "Something went wrong. Please refresh.";
};

function ErrorFallback({ error }: FallbackProps) {
  return (
    <div className="p-4 text-red-600">
      {getErrorMessage(error)}
    </div>
  );
}

export default function App() {
  return (
    <AppErrorBoundary FallbackComponent={ErrorFallback}>
      <RouterProvider router={router} />
      <Toaster 
        position="top-right"
        toastOptions={{
          className: '!pr-8', // Add padding to prevent text overlapping with close button
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== 'loading' && (
                  <button
                    onClick={() => toast.dismiss(t.id)}
                    className="absolute right-1 top-1 rounded-full p-1 hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors"
                    aria-label="Close"
                  >
                    <X className="w-4 h-4" />
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </AppErrorBoundary>
  );
}
  